// extracted by mini-css-extract-plugin
export var container = "_2e-0";